const { activityTypes } = require('./activities');

module.exports = {
  activityTypes,
}
